.jw{pointer-events:auto;}